import request from '@/utils/request'

// 获取首页数据
export const getHomeData = () => {
  return request({
    url: '/erp/home/list',
    method: 'post'
  })
}

// 获取当前用户信息
export const getUserData = () => {
  return request({
    url: '/erp/mshop/user-info',
    method: 'get'
  })
}

// 获取员工首页数据
export const getHomeStaffDay = () => {
  return request({
    url: '/erp/home/staff-day',
    method: 'post'
  })
}


// 获取员工首页数据
export const getHomeStaffDate = () => {
  return request({
    url: '/erp/home/staff-data',
    method: 'post'
  })
}
